/**
 * 浏览器种类、版本相关函数
 * @author elvinpeng
 *
 */

const isClient = typeof window === 'object' && window && typeof document !== 'undefined';
const isServer = !isClient

const ua = isClient ? navigator.userAgent.toLowerCase() : '';
const platform = isClient ? navigator.platform.toLowerCase() : '';

/**
 * 根据 userAgent 判断是否被微信打开
 */
function isWeixin() {
  return ua.indexOf('micromessenger') !== -1;
}

/**
 * 根据 userAgent 判断是否被 QQ 打开
 */
function isQQ() {
  return !!getQQVersion();
}

/**
 * 根据 userAgent 判断是否被课堂或辅导 App 打开
 */
function isApp() {
  // android 新版 ua 改成 eduapp
  return ua.indexOf('educationapp') !== -1 || ua.indexOf('eduapp') != -1;
}

/**
 * 根据 userAgent 判断是否被 IOS 系统打开(包括 IPhone/IPod/IPad)
 */
function isIos() {
  return /iphone|ipod|ipad|ios/.test(ua);
}

/**
 * 根据 userAgent 判断是否被 Android 打开
 */
function isAndroid() {
  return /android/.test(ua);
}

/**
 * 根据 userAgent 判断是否被 QQ 浏览器打
 */
function isQQBrowser() {
  return ua.indexOf('mqqbrowser') != -1;
}

/**
 * 根据 userAgent 获取 QQ 版本
 * 获取失败时返回 0
 */
function getQQVersion() {
  const match = ua.match(/qq\/(\d+\.\d+(\.\d+)?)/i);
  return match && match[1] || 0;
}

/**
 * 根据 userAgent 获取课堂|辅导 App 版本
 * 不是 App 或者获取失败时返回 0
 */
function getAppVersion() {
  if (!isApp()) {
    return 0;
  }

  const version = (/versioncode\/(\d+)/.exec(ua) || [])[1];
  return version || 0;
}

/**
 * 根据 navigator.platform 判断平台
 * @returns {string} 'app' | 'pc' | 'h5'
 */
function getPlatform() {
  if (isApp()) {
    return 'app';
  } else if (/win|macintel|linux/i.test(platform)) {
    return 'pc';
  } else {
    return 'h5';
  }
}

/**
 * 根据 userAgent 判断手机类型
 *
 * @returns {number}
 * 1 - ios
 * 2 - android
 * 3 - others
 */
function getPlatformCode() {
  if (isIos()) {
    return 1;
  } else if (isAndroid()) {
    return 2;
  } else {
    return 3;
  }
}

 export {
  isWeixin,
  isQQ,
  isApp,
  isIos,
  isAndroid,
  isQQBrowser,
  getQQVersion,
  getAppVersion,
  getPlatform,
  getPlatformCode,
}







